type PageObject = {
  name: string
  description: string
}

type ImpactModulePages = {
  [key: string]: PageObject
}

export const ACTIVITIES_PAGES: ImpactModulePages = {
  ACTIVITY: {
    name: 'Atividades',
    description: 'Gestão das atividades',
  },
  ACTIVITY_TYPE: {
    name: 'Tipos de atividades',
    description: 'Gestão dos tipos de atividade',
  },
  GROUP_MODULE_PERMISSION: {
    name: 'Permissões de grupo',
    description: 'Gestão das permissões de grupos',
  },
  PUBLIC_AGENT_MODULE_PERMISSION: {
    name: 'Permissões de agentes',
    description: 'Gestão das permissões dos agentes',
  },
}
